var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAssign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.03906 0 0 .03906 2 2)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242 492c0 11.047-8.953 20-20 20H107c-44.113 0-80-35.887-80-80V80c0-44.113 35.887-80 80-80h245.891c44.109 0 80 35.887 80 80v212c0 11.047-8.957 20-20 20-11.047 0-20-8.953-20-20V80c0-22.055-17.946-40-40-40H107c-22.055 0-40 17.945-40 40v352c0 22.055 17.945 40 40 40h115c11.047 0 20 8.953 20 20Zm235.641-166.262c-8.981-6.429-21.473-4.359-27.903 4.617l-98.582 137.704c-2.691 3.121-6.066 3.793-7.871 3.914-1.867.121-5.476-.114-8.574-3.063l-63.82-61.281c-7.965-7.649-20.625-7.395-28.278.574-7.652 7.969-7.394 20.629.575 28.277l63.882 61.344C316.641 506.93 329.41 512 342.551 512c1.129 0 2.262-.039 3.394-.113 14.313-.953 27.676-7.914 36.664-19.102.231-.285.457-.582.672-.883l98.981-138.261c6.429-8.981 4.363-21.473-4.621-27.903ZM332.891 120h-206c-11.047 0-20 8.953-20 20s8.953 20 20 20h206c11.043 0 20-8.953 20-20s-8.957-20-20-20Zm20 100c0-11.047-8.957-20-20-20h-206c-11.047 0-20 8.953-20 20s8.953 20 20 20h206c11.043 0 20-8.953 20-20Zm-226 60c-11.047 0-20 8.953-20 20s8.953 20 20 20H252c11.047 0 20-8.953 20-20s-8.953-20-20-20H126.891Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssign);
export default __webpack_public_path__ + "static/media/ic-assign.4e0f6da98d2be364be3d8ae7bdfef1bb.svg";
export { ForwardRef as ReactComponent };